import React from "react";
export const MyAssessmentContext = React.createContext({
    showFinishFooter: false,
    isAssessment: false,
    disableNext: false
})
